__turbopack_context__.v({
  "aff__link": "DealsPageAffiliateButton-module__ztMXZa__aff__link",
  "aff_four-column": "DealsPageAffiliateButton-module__ztMXZa__aff_four-column",
  "authorSearchAff": "DealsPageAffiliateButton-module__ztMXZa__authorSearchAff",
  "dealspage__book_retailers": "DealsPageAffiliateButton-module__ztMXZa__dealspage__book_retailers",
  "dealspage__buy_button": "DealsPageAffiliateButton-module__ztMXZa__dealspage__buy_button",
  "dealspage__buy_button_ORM": "DealsPageAffiliateButton-module__ztMXZa__dealspage__buy_button_ORM",
  "dealspage__buy_button_disabled": "DealsPageAffiliateButton-module__ztMXZa__dealspage__buy_button_disabled",
  "dealspage__dropdown": "DealsPageAffiliateButton-module__ztMXZa__dealspage__dropdown",
  "searchAff": "DealsPageAffiliateButton-module__ztMXZa__searchAff",
  "select": "DealsPageAffiliateButton-module__ztMXZa__select",
});
